// extracted by mini-css-extract-plugin
export default {"domain_select":"_5iKpGzaOs-PrLUSVit+bFA=="};